<template>
	<div>
		<template>
			<div class="yx-color-text-primar confirmCooGoods-title fz-16 yx-pingfang-Medium pl-8">合作商品</div>
		</template>
		<BaseTable :columns="columns" :list="goodsSpuList" :options="options" class="mt-16 goods-table"></BaseTable>
		<div class="pt-12 pr-16 pb-12 pl-16 font-h4-regular" v-if="isBatch">
			<el-button class="cursor-pointer" type="text" @click="addGoods" :disabled="goodsTotal >= goodsLimit">+ 添加商品</el-button>
			<span class="yx-color-text-secondary ml-4">({{ goodsTotal }}/{{ goodsLimit }})</span>
		</div>
		<add-goods-drawer ref="addGoodsDrawer" @returnSelect="returnSelect" :platformId="platformId" :max-selected="10" />
	</div>
</template>
<script>
import addGoodsDrawer from './components/addGoodsDrawer.vue';
import columns, { operations } from './columns';
export default {
	name: 'ConfirmCooGoods',
	components: {
		addGoodsDrawer,
	},
	props: {
		isBatch: {
			type: Boolean,
			default: false,
		},
		chooseGoodsList: {
			type: Array,
			default: () => [],
		},
		platformId: {
			type: [Number, String],
			default: dataMap.PLATFORM_DY.value,
		},
	},
	watch: {
		chooseGoodsList: {
			handler(val) {
				let arr = JSON.parse(JSON.stringify(val));
				arr.forEach(item => {
					item.nums = 0;
					item.platform_id = this.platformId;
				});
				this.goodsSpuObj = arr.reduce((total, prev) => {
					!total[prev.productId] && (total[prev.productId] = [prev]);
					return total;
				}, {});
			},
			deep: true,
			immediate: true,
		},
		goodsSpuObj: {
			handler(val) {
				if (Object.keys(val).length) {
					this.$emit('checkSelectGoods', true);
				} else {
					this.$emit('checkSelectGoods', false);
				}
			},
			deep: true,
		},
	},
	computed: {
		thirdProductIdList({ selectGoods }) {
			let arr = selectGoods.map(item => item.thirdProductId);
			return [...new Set(arr)];
		},
		productIdList({ selectGoods }) {
			let arr = selectGoods.map(item => item.productId);
			return [...new Set(arr)];
		},
		goodsTotal({ goodsSpuObj }) {
			return Object.keys(goodsSpuObj).length;
		},
		priceTotal({ goodsSpuList }) {
			return goodsSpuList.reduce((total, item) => total + Number(item.price) * item.nums, 0).toFixed(2);
		},
		isDisableDel({ goodsSpuObj }) {
			return Object.keys(goodsSpuObj).length <= 1;
		},
		// 商品spu列表，用于渲染商品列表
		goodsSpuList() {
			return this.calculateSpan(this.goodsSpuObj);
		},
	},
	data() {
		return {
			selectGoods: [],
			goodsSpuObj: [],
			columns: [],
			options: {
				border: false,
			},
			// 最多只能选中的商品spu个数
			goodsLimit: 10,
		};
	},
	created() {
		// 批量申样才会有删除商品操作
		this.columns = this.isBatch ? [...columns, operations] : columns;
	},
	methods: {
		addGoods() {
			this.$refs.addGoodsDrawer.show(this.goodsSpuObj);
		},
		returnSelect(val) {
			// console.log('新增的商品', val);
			const selectedObj = val.reduce((total, prev) => {
				prev.platform_id = this.platformId;
				total[prev.productId] = [prev];
				return total;
			}, {});
			this.goodsSpuObj = { ...this.goodsSpuObj, ...selectedObj };
			// console.log('变更后的spu对象数据：', this.goodsSpuObj);
		},
		getSelectList() {
			return this.goodsSpuObj;
		},
		reset() {
			this.goodsSpuObj = [];
			this.selectGoods = [];
		},
		delGoods(productId) {
			// console.log('需要删除的spu商品ID：', productId);
			const _obj = { ...this.goodsSpuObj };
			delete _obj[productId];
			this.goodsSpuObj = _obj;
			// console.log('变更后的spu对象数据：', this.goodsSpuObj);
		},
		handleChange(val, { id, productId }) {
			this.goodsSpuObj[productId].find(item => item.id === id).nums = val;
			this.goodsSpuObj = { ...this.goodsSpuObj };
		},

		getButtons() {
			return [
				{
					label: '删除',
					type: 'text',
					disabled: this.isDisableDel,
					click: row => this.delGoods(row.productId),
				},
			];
		},
		calculateSpan(obj) {
			const _list = [];
			Object.keys(obj).forEach(productId => {
				let __list = [];
				const choosed = obj[productId].filter(item => item.choosed);
				if (!choosed.length) {
					__list = [{ ...obj[productId][0], specification: '', nums: 0, operations: this.getButtons(), rowspan: 1, colspan: 1 }];
				} else {
					__list = [
						...choosed.map((item, index) => {
							// 删除按钮需要重新渲染，存在逻辑为只有一个spu时删除按钮禁用
							item.operations = this.getButtons();
							if (!item.platform_id) {
								item.platform_id = this.platformId;
							}
							if (index === 0) {
								item.rowspan = choosed.length;
								item.colspan = 1;
							} else {
								item.rowspan = 0;
								item.colspan = 0;
							}
							return { ...item };
						}),
					];
				}
				_list.push(...__list);
			});
			return _list;
		},
	},
};
</script>
<style lang="less" scoped>
.footer {
	padding: 14px 0px;
	background-color: #f7f8fa;
	border-radius: 2px;
	p {
		padding: 0px 16px;
		box-sizing: border-box;
	}
}
/deep/.el-tag--plain.el-tag--info {
	border-color: #e1e3e8 !important;
}
/deep/.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
	background-color: #ffffff;
}
/deep/.el-table--enable-row-transition .el-table__body td.el-table__cell {
	&:nth-child(1),
	&:nth-child(2),
	&:nth-child(6) {
		vertical-align: middle;
	}
}
/deep/.table-btns {
	height: 65px;
}
.confirmCooGoods-title{
	position: relative;
	color: @color-gy9;
	font-weight: 500;
}
.confirmCooGoods-title::before {
	content: '';
	width: 3px;
	height: 17px;
	background: @color-b4;
	border-radius: 20px;
	position: absolute;
	left: 0px;
	top: 50%;
	transform: translateY(-50%);
}
.goods-table{
	/deep/ .el-table__header-wrapper{
		border-radius: 4px 4px 0 0 !important;
	}
	/deep/ .el-table__header-wrapper tr{
		background: @color-gy3 !important;
	}
	/deep/ th.el-table__cell{
		background: none;
		padding: 8px 0 8px 0px !important;
	}
	/deep/ .el-table__header{
		width: 100% !important;
	}
	/deep/ .el-table__body{
		width: 100% !important;
	}
	/deep/ .cell{
		font-size: 14px !important;
		color:@color-regular !important;
		font-weight: normal !important;
	}
}
/deep/ .goods-table::before{
	height: 0px !important;
}
</style>
